export const RELATION_TYPE_THEME_MAP = {
    Member: "indigo",
    Partner: "purple",
    Sponsor: "cyan",
};
export function getRelationTypeBadgeTheme(relationType) {
    return RELATION_TYPE_THEME_MAP[relationType] ?? "neutral";
}
